import React, { useState } from 'react';
import PillTab from 'components/common/pillTab';
import { NoticeBoard } from './components/NoticeBoard';
import EventList from '../upcomingEvents/components/EventList';
import { NOTICE_PILL_TAB_OPTIONS } from 'constants/appConstants';
type NoticeTab = (typeof NOTICE_PILL_TAB_OPTIONS)[number]['value'];

interface FiscalYear {
  startDate?: string;
  endDate?: string;
}

interface NoticeAndEventsProps {
  currentFiscalYear: FiscalYear;
}

export const NoticeAndEvents: React.FC<NoticeAndEventsProps> = ({ currentFiscalYear }) => {
  const [activeTab, setActiveTab] = useState<NoticeTab>(() => {
    const dayOfMonth = new Date().getDate();
    return dayOfMonth % 2 === 0 ? 'events' : 'notice';
  });

  const onToggleChange = (newValue: string | number) => {
    setActiveTab(newValue as NoticeTab);
  };

  const isNoticeTab = activeTab === 'notice';

  return (
    <div className="full-scope-card dashboard__card d-flex flex-direction-column">
      <div className="dashboard__title d-flex justify-content-between">
        <div>What's Happening?</div>
        <PillTab tabs={NOTICE_PILL_TAB_OPTIONS} onTabClick={onToggleChange} isActive={(value) => value === activeTab} />
      </div>

      {isNoticeTab ? <NoticeBoard /> : currentFiscalYear.endDate && <EventList currentFiscalYear={currentFiscalYear} />}
    </div>
  );
};

export default NoticeAndEvents;
